module.exports = __webpack_public_path__ + "img/booking.67f91c45.png";